var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-email"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.email_address.length > 0) ? _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.client.default_email_address))])]) : (_vm.client.using_email === false) ? _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('span', {
    staticClass: "text-secondary"
  }, [_c('i', {
    staticClass: "fa fa-envelope-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Klient nepoužívá email")])]) : _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-envelope-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chybí emailová adresa")])])]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("E-mailové adresy klienta")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_vm._v("Klient používá email ")]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientForUpdate.using_email),
      expression: "clientForUpdate.using_email"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "usingEmail",
      "data-testid": "client-email-using-toggle",
      "disabled": _vm.clientPending
    },
    domProps: {
      "checked": Array.isArray(_vm.clientForUpdate.using_email) ? _vm._i(_vm.clientForUpdate.using_email, null) > -1 : (_vm.clientForUpdate.using_email)
    },
    on: {
      "change": _vm.saveUsingMail,
      "__c": function($event) {
        var $$a = _vm.clientForUpdate.using_email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.clientForUpdate.using_email = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.clientForUpdate.using_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clientForUpdate.using_email = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), (_vm.client.using_email) ? [(_vm.client.email_address.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-7"
  }, [_vm._v("emailová adresa")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("výchozí")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.client.email_address), function(ea) {
    return [_c('tr', {
      staticClass: "row m-0 text-left",
      class: ea.default ? 'font-weight-bold' : '',
      attrs: {
        "data-testid": "client-email-row"
      }
    }, [(_vm.editingId !== ea.id) ? _c('td', {
      staticClass: "col-sm-7"
    }, [_vm._v(_vm._s(ea.email))]) : _vm._e(), _vm._v(" "), (_vm.editingId !== ea.id) ? _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(_vm._f("boolToCS")(ea.default)))]) : _c('td', {
      staticClass: "col-sm-10"
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.submitFormUpdateEmailAddress($event)
        }
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedEmailAddress.email),
        expression: "updatedEmailAddress.email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "e-mailová adresa",
        "data-testid": "client-email-edit-input",
        "id": "emailAddress"
      },
      domProps: {
        "value": (_vm.updatedEmailAddress.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedEmailAddress.email = $event.target.value
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                                                  Výchozí: \n                                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedEmailAddress.default),
        expression: "updatedEmailAddress.default"
      }],
      attrs: {
        "type": "checkbox",
        "data-testid": "client-email-edit-default"
      },
      domProps: {
        "checked": Array.isArray(_vm.updatedEmailAddress.default) ? _vm._i(_vm.updatedEmailAddress.default, null) > -1 : (_vm.updatedEmailAddress.default)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.updatedEmailAddress.default,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.updatedEmailAddress.default = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.updatedEmailAddress.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.updatedEmailAddress.default = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.updatedEmailAddress.note),
        expression: "updatedEmailAddress.note"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "data-testid": "client-email-edit-note",
        "id": "emailAddressNote",
        "placeholder": "poznámka"
      },
      domProps: {
        "value": (_vm.updatedEmailAddress.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.updatedEmailAddress.note = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.updatedEmailAddressPending === false) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "data-testid": "client-email-edit-save",
        "type": "submit"
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.updatedEmailAddressError.email) ? _c('small', {
      staticClass: "form-text text-danger text-left",
      attrs: {
        "id": "emailError"
      }
    }, [_vm._v(_vm._s(_vm.updatedEmailAddressError.email.message))]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "text-right col-sm-2"
    }, [(_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": "client-email-delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteEmailAddress(ea.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (_vm.editingId === ea.id) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": "client-email-edit-cancel"
      },
      on: {
        "click": function($event) {
          _vm.setEditingEmailAddress(ea)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : (_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": "client-email-edit"
      },
      on: {
        "click": function($event) {
          _vm.setEditingEmailAddress(ea)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), (ea.note !== null && ea.note !== '' && _vm.editingId !== ea.id) ? _c('tr', {
      staticClass: "row m-0 "
    }, [_c('td', {
      staticClass: "col-sm-12 text-left border-top-0 pt-0 font-italic"
    }, [_vm._v("Poznámka: " + _vm._s(ea.note))])]) : _vm._e()]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editingId === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitFormAddEmailAddress($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmailAddress.email),
      expression: "newEmailAddress.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "e-mailová adresa",
      "data-testid": "client-email-input",
      "id": "emailAddress"
    },
    domProps: {
      "value": (_vm.newEmailAddress.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmailAddress.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                      Výchozí: \n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmailAddress.default),
      expression: "newEmailAddress.default"
    }],
    attrs: {
      "type": "checkbox",
      "data-testid": "client-email-default"
    },
    domProps: {
      "checked": Array.isArray(_vm.newEmailAddress.default) ? _vm._i(_vm.newEmailAddress.default, null) > -1 : (_vm.newEmailAddress.default)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.newEmailAddress.default,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newEmailAddress.default = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.newEmailAddress.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newEmailAddress.default = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmailAddress.note),
      expression: "newEmailAddress.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-email-note",
      "id": "emailAddressNote",
      "placeholder": "poznámka"
    },
    domProps: {
      "value": (_vm.newEmailAddress.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmailAddress.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newEmailAddressPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "client-email-add",
      "type": "submit"
    }
  }, [_vm._v("Přidat e-mail")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.newEmailAddressError.email) ? _c('small', {
    staticClass: "form-text text-danger text-left",
    attrs: {
      "id": "emailError"
    }
  }, [_vm._v(_vm._s(_vm.newEmailAddressError.email.message))]) : _vm._e()])])]) : _vm._e()] : _vm._e()], 2)])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6da495f5","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientEmailAddress.vue
// module id = 337
// module chunks = 0